import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setSending(state, payload) {
    state.isSending = payload;
  },
  setResponse(state, payload) {
    state.response = payload;
  },
  setBalances(state, payload) {
    state.balances = payload;
  },
};
